import React from "react";
import { connect } from "react-redux";
import {Scrollbar} from "react-scrollbars-custom";
import { alertError, confirm, toastInfo, toastError } from "actions/ui";
import { markFeedEntryAsSeen, mergeFeed } from "actions/application";
import { sendUserCommand, clearUserCommand } from "actions/commands";
import { focusChannel, openChannel } from "actions/ui";
import { addChannel } from "actions/application";
import {sprintf} from "utils/string";
import Time from "ui/common/channel/messages/message/Time";
import PropTypes from "prop-types";
import Loader from "ui/common/Loader";

class Feed extends React.Component {

	constructor(props) {
		super(props);

		this.state = { }

		this.handleClick = this.handleClick.bind(this);
		this.renderEntry = this.renderEntry.bind(this);
		this.handleStopScroll = this.handleStopScroll.bind(this);
	}

	componentDidMount() {
		this.props.clearUserCommand('userFeed');
	}

	componentDidUpdate(prevProps) {
		const commandFailure = this.props.command !== prevProps.command && this.props.command && this.props.command.success === false;
		const addFailure = this.props.addMember !== prevProps.addMember && this.props.addMember && this.props.addMember.success === false;
		const addSuccess = this.props.addMember !== prevProps.addMember && this.props.addMember && this.props.addMember.success === true;
		const confirmFailure = this.props.confirmChannelMembership?.success !== prevProps.confirmChannelMembership?.success && this.props.confirmChannelMembership?.success === false;
		const confirmSuccess = this.props.confirmChannelMembership?.success !== prevProps.confirmChannelMembership?.success && this.props.confirmChannelMembership?.success === true;
		const addUserChannelFailure = this.props.addUserChannel !== prevProps.addUserChannel && this.props.addUserChannel && this.props.addUserChannel.success === false;
		const addUserChannelSuccess = this.props.addUserChannel !== prevProps.addUserChannel && this.props.addUserChannel && this.props.addUserChannel.success === true;
		const feedResultSuccess = this.props.getFeed !== prevProps.getFeed && this.props.getFeed && this.props.getFeed.success === true;

		if (commandFailure) {
			this.props.alertError(this.props.command.error);
			this.props.clearUserCommand('userFeed');
		}
		if (addFailure) {
			this.props.alertError(this.props.addMember.error);
			this.props.clearUserCommand('addChannelMember');
		}
		if (addSuccess) {
			this.props.clearUserCommand('addChannelMember');
			this.props.toastInfo(this.props.i18n.userAddedToChannel);
		}

		if (confirmFailure) {
			this.props.alertError(this.props.confirmChannelMembership.error);
			this.props.clearUserCommand('confirmChannelMembership');
		}
		if (confirmSuccess) {
			const channel = this.props.confirmChannelMembership.result.channel;
			this.props.addChannel(channel);
			this.props.openChannel(channel.id);
			this.props.focusChannel(channel.id);
			this.props.clearUserCommand('confirmChannelMembership');
			this.props.toastInfo(this.props.i18n.youJoinedChannel);
		}

		if (addUserChannelFailure) {
			this.props.alertError(this.props.addUserChannel.error);
			this.props.clearUserCommand('addUserChannel');
		}
		if (addUserChannelSuccess) {
			const channel = this.props.addUserChannel.result.channel;
			this.props.addChannel(channel);
			this.props.openChannel(channel.id);
			this.props.focusChannel(channel.id);
			this.props.clearUserCommand('addUserChannel');
			this.props.toastInfo(this.props.i18n.addedChannelToList);
		}
		if (feedResultSuccess) {
			if (this.props.getFeed.result.feed.length === 0) {
				this.setState({ noPastMessages: true });
			} else {
				this.props.mergeFeed(this.props.getFeed.result.feed);
			}
		}
	}

	handleClick(userFeedEntry) {
		this.markAsSeen(userFeedEntry);

		switch(userFeedEntry.type) {
			case 'channels.member.join.request':
				this.props.confirm(this.props.i18n.askToAcceptRequest, function() {
					this.props.sendUserCommand('addChannelMember', 'addChannelMember', { channelId: userFeedEntry.channel.id, userId: userFeedEntry.user.id });
				}.bind(this));

				break;
			case 'channels.member.invitation':
				this.props.confirm(this.props.i18n.askToAcceptInvitation, function() {
					this.props.sendUserCommand('confirmChannelMembership', 'confirmChannelMembership', { channelId: userFeedEntry.channel.id });
				}.bind(this));

				break;
			case 'channels.notification':
				if (this.props.channels.find( channel => channel.id === userFeedEntry.channel.id )) {
					this.props.openChannel(userFeedEntry.channel.id);
					this.props.focusChannel(userFeedEntry.channel.id);
				} else {
					this.props.sendUserCommand('addUserChannel', 'addUserChannel', { channelId: userFeedEntry.channel.id });
				}
				break;
		}
	}

	markAsSeen(userFeedEntry) {
		if (!userFeedEntry.seen) {
			this.props.markFeedEntryAsSeen(userFeedEntry.id);
			this.props.sendUserCommand('userFeed', 'markFeedEntryAsSeen', {id: userFeedEntry.id});
		}
	}

	renderEntry(userFeedEntry, index, array) {
		return <div key={ userFeedEntry.id } className={ 'wcRecent ' + (userFeedEntry.seen ? 'wcRead' : 'wcUnread' ) + (index === 0 ? ' wcFirst' : '') + (index + 1 === array.length ? ' wcLast' : '') } onClick={ e => this.handleClick(userFeedEntry) }>
			<div className="wcRight">
				<div className="wcHead">
					<span className="wcName">{ this.renderTitle(userFeedEntry) }</span>
					<Time timeUTC={ userFeedEntry.created } />
				</div>
			</div>
		</div>
	}

	renderTitle(entry) {
		switch(entry.type) {
			case 'channels.notification':
				return <React.Fragment>{ this.props.i18n.askToVisit } <strong>{entry.channel ? entry.channel.name : this.props.i18n.unknown }</strong></React.Fragment>
			case 'channels.member.added':
				return <React.Fragment>{ this.props.i18n.addedToChannel } <strong>{entry.channel ? entry.channel.name : this.props.i18n.unknown }</strong></React.Fragment>
			case 'channels.member.invitation':
				return <React.Fragment>{ this.props.i18n.askedToJoin } <strong>{entry.channel ? entry.channel.name : this.props.i18n.unknown }</strong></React.Fragment>
			case 'channels.member.deleted':
				return <React.Fragment>{ this.props.i18n.removedFromChannel } <strong>{entry.channel ? entry.channel.name : this.props.i18n.unknown }</strong></React.Fragment>
			case 'channels.member.join.request':
				return <React.Fragment>{ sprintf(this.props.i18n.userRequestsToJoin, entry.user ? entry.user.name : this.props.i18n.unknown ) } <strong>{entry.channel ? entry.channel.name : this.props.i18n.unknown}</strong></React.Fragment>
			default:
				return entry.type;
		}
	}

	handleStopScroll(scrollValues) {
		if (!this.state.noPastMessages && this.props.userFeed.length > 0) {
			if (scrollValues.scrollHeight - scrollValues.scrollTop === scrollValues.clientHeight) {
				this.props.sendUserCommand('getFeed', 'getFeed', { lastId: this.props.userFeed[this.props.userFeed.length - 1].id });
			}
		}
	}

	render() {
		return(
			<div className={'wcRecentContainer' + (!this.props.visible ? ' wcInvisible' : '')}>
				{this.props.userFeed.length > 0 ? (
					<Scrollbar onScrollStop={ this.handleStopScroll } noScrollX={ true }>
						{this.props.userFeed.map((userFeedEntry, index, array) => this.renderEntry(userFeedEntry, index, array))}
						{ this.props.getFeed?.inProgress === true && <Loader message={ this.props.i18nBase.loading } center={ true } marginTop={ 10 } marginBottom={ 10 } /> }
					</Scrollbar>
				) : (
					<span className="wcNoRecent">{this.props.i18n.feedEmpty}</span>
				)}
			</div>
		);
	}

}

Feed.propTypes = {
	visible: PropTypes.bool
};

export default connect(
	(state) => ({
		i18n: state.application.i18n,
		i18nBase: state.configuration.i18n,
		configuration: state.configuration,
		channels: state.application.channels,
		userFeed: state.application.userFeed,
		command: state.commands.sent.userFeed,
		ignoredChannels: state.ui.ignoredChannels,
		addMember: state.commands.sent.addChannelMember,
		confirmChannelMembership: state.commands.sent.confirmChannelMembership,
		addUserChannel: state.commands.sent.addUserChannel,
		getFeed: state.commands.sent.getFeed
	}),
	{ markFeedEntryAsSeen, mergeFeed, alertError, sendUserCommand, clearUserCommand, confirm, toastInfo, toastError, focusChannel, openChannel, addChannel }
)(Feed);